import { useCallback } from "react";
import Cookies from "js-cookie";

import { SIGN_UP_US } from "../../../../../../../config/Endpoints.js";
import { postApi } from "../../../../../../utils/api.ts";
import type { UsPreJoinSignupPayload } from "../mappers/us-pre-join.mapper.ts";

export function useUsPreJoinSignup() {
  const signup = useCallback(async (payload: UsPreJoinSignupPayload) => {
    await postApi(
      SIGN_UP_US,
      Cookies.get("accessToken"),
      payload as unknown as Record<string, unknown>,
    );
  }, []);

  return { signup };
}
